import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconExitFullscreen = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <polygon points="41.7,85 32.2,75.6 23.9,83.9 16.1,76.1 24.4,67.8 15,58.3 41.7,58.3"/>
        <polygon points="85,58.3 75.6,67.8 83.9,76.1 76.1,83.9 67.8,75.6 58.3,85 58.3,58.3"/>
        <polygon points="58.3,15 67.8,24.4 76.1,16.1 83.9,23.9 75.6,32.2 85,41.7 58.3,41.7"/>
        <polygon points="15,41.7 24.4,32.2 16.1,23.9 23.9,16.1 32.2,24.4 41.7,15 41.7,41.7"/>
    </svg>
);

export default IconExitFullscreen;